import React, { useEffect, useState } from "react";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";
import Select from "react-select";
import apiClient from "../api/apiClient";
import axios from "axios";
import { Button } from "@mui/material";
import { apiUrl } from "../authconfig";
const UserAssignModal = (props) => {
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const currentUser = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
 
    apiClient
      .get(`${apiUrl}/api/assign-users`)
      .then((response) => {
        const user= {
          "id": "12345",
          "userPrincipalName": currentUser.mail.toLowerCase() || "",
          "displayName": currentUser.displayName.toLowerCase() || "",
          "objectType": "User",
          "userType": "Member",
          "guest": false,
          "user": false,
          "group": false
      }
      

      const data = response.data.map((item) => ({
        ...item,
        userPrincipalName: item.userPrincipalName.toLowerCase() || "",
        displayName: item.displayName.toLowerCase() || "",
      }));
      // const userExists = data.some(
      //   (item) => item.userPrincipalName === user.userPrincipalName
      // );

      // if (!userExists) {
      //   data.push(user);
      // }
      const notIncludedUsers = props.userListOptionToConcat
      ?.map((item) => item?.toLowerCase() || "")
      .filter(
        (item) =>
          !data.some((user) => user.userPrincipalName === item)
      );
console.log("notIncludedUsers", notIncludedUsers,data);
      if(notIncludedUsers.length > 0) {
        notIncludedUsers.forEach((item) => {
        data.push({
          userPrincipalName: item,
          displayName: item
        });
      })
    }
        setUserList(data);
      })
      .catch((error) => {
        console.error("Error fetching the filter options:", error);
      });
  }, []);

  const handleSubmit = () => {
    
    if (!selectedUser?.value) {
      alert("Please select a user before submitting.");
      return;
    }
    const selectedRowId = props.rowSelectionModel;
    const data = props.rows;
    const selectedRow = data?.filter((item) =>
      selectedRowId?.includes(item?.id)
    );

    const payload = selectedRow.map((item) => {
      return { ...item, assignedUser: selectedUser?.value,modifiedBy: currentUser?.mail };
    });
    console.log("selectedRow", selectedRow);

    apiClient
      .post(`${apiUrl}/api/opportunities/saveOpportunities`, payload)
      .then((response) => {
        const email = selectedUser?.value || "";
        const localPart = email.split("@")[0] || "";
        const firstNameFromEmail = (localPart.split(".")[0] || localPart) || "";
        console.log("firstNameFromEmail", firstNameFromEmail);

        // Trigger one email per selected assignment so each email has project-specific details
        const url =
          "https://b80dec4667eb4e738f187b878c62b6.6d.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/94cc6aca63e049e18c158129ac4e8c40/triggers/manual/paths/invoke";
        const axiosOptions = {
          headers: { "Content-Type": "application/json" },
          params: {
            "api-version": 1,
            sp: "/triggers/manual/run",
            sv: "1.0",
            sig: "LPEafpZLDAl5_ngVhcPWGB04pdFLS9P2cdwKhH51Bl4",
          },
        };

        const emailRequests = (selectedRow || []).map((row) => {
          const gpUsd = Number(String(row?.grossProfit ?? "").replace(/,/g, "")) || 0;
          const perEmailPayload = {
            assigned_user_name: firstNameFromEmail,
            assigned_user_mail: email,
            Project_Id: row?.projectId || "",
            closed_won_date: row?.closedWonDate || "",
            account_name: row?.accountName || "",
            gp_usd: gpUsd,
            ionis_link:
              `<a href="https://ionis-dev.maersk-digital.net/opportunities" target="_blank" rel="noopener noreferrer">Open Opportunities</a>`,
          };
          return axios.post(url, perEmailPayload, axiosOptions);
        });

        Promise.allSettled(emailRequests)
          .then((results) => {
            const failures = results.filter((r) => r.status === "rejected").length;
            if (failures > 0) {
              alert(`${failures} of ${results.length} email notification(s) failed to send.`);
            } else {
              console.log("All email triggers invoked successfully");
            }
          })
          .finally(() => {
            props.handleClose();
            props.setAssignModal(false);
            props.setRowSelectionModel([]);
          });
      })
      .catch((error) => {});
  };

  const handleUserAssign = (value) => {
    setSelectedUser(value);
  };

  
  return (
    <div>
      <McModal
        closed={() => {
          props.setAssignModal(false);
        }}
        open={props.assignModal}
        width="50vw"
        height="40vh"
      >
        <div
          style={{
            marginBottom: "20px",
            background: "rgb(66, 176, 213)",
            color: "#fff",
            justifyContent: "space-evenly",
            borderRadius: "5px",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              margin: "5px",
              fontFamily: "Maersk Text",
            }}
          >
            <b>Assign User</b>
          </p>
        </div>

        <div>
          <Select
            options={userList.map((item) => ({
              value: item?.userPrincipalName,
              label: item?.userPrincipalName,
            }))}
            placeholder="User List"
            isClearable
            value={selectedUser}
            onChange={(value) => handleUserAssign(value)}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <Button
            variant="contained"
            style={{
              display: "block",
              margin: "20px auto",
              justifyItems: "center",
              width: "150px",
              padding: "10px",
              backgroundColor: selectedUser?.value ? "#00243D" : "#9e9e9e",
            }}
            //disabled={!selectedUser?.value}
            onClick={() => handleSubmit()}
          >
            Submit
          </Button>
        </div>
      </McModal>
    </div>
  );
};

export default UserAssignModal;
